import React, { useEffect, useState } from 'react';
import Pagination from 'b2b-ui-components-lib/lib/components/pagination';
import Select from 'b2b-ui-components-lib/lib/components/select';
import { getShowRowsOptions, SHOWROWS_ENUM } from './table.constant';
import { isAOIOrder } from 'common/constants/app.constants';

const TableFooter = ({ currentPage, setCurrentPage, totalPages, emitShowRowsChange, hide, totalRecords, paginationLength, numberOfRowsToShow }) => {
  const [showRows, setShowRows] = useState(getShowRowsOptions(SHOWROWS_ENUM.options, totalRecords)[0]);
  const onShowRowsChange = (selected) => {
    setShowRows(selected);
    emitShowRowsChange(selected.key);
  };

  useEffect(() => {
    console.log('useEffectTableFooter', numberOfRowsToShow);
    setShowRows(getShowRowsOptions(SHOWROWS_ENUM.options, totalRecords).filter((obj) => obj.key === numberOfRowsToShow)[0]);
  }, [numberOfRowsToShow]);

  return (
    <React.Fragment>
      {!hide && (
        <div className="table-footer">
          <Select options={getShowRowsOptions(SHOWROWS_ENUM.options, totalRecords)} value={showRows} onChange={onShowRowsChange} variant="compact" label="Show" required />
          <Pagination currentPage={currentPage} totalPages={totalPages} length={paginationLength} onPageSelect={(page) => setCurrentPage(page)} />
        </div>
      )}
    </React.Fragment>
  );
};

export default TableFooter;
